<template>
  <div>
    <router-view/>
    <v-loader v-if="showLoader" :blocking="true"/>
    <div class="confirm-modal-container">
      <modal
        v-if="!alert.dismissed && alert.messages.length"
        :modal-id="'flashMessage'"
        :modal-class="'confirm-modal'"
        :title-id="'flashMessageTitle'"
        @close="closeErrorNotication"
      >
        <h2 v-html="alert.title"/>
        <alert-message
          v-for="(message, index) in alert.messages"
          :message="message"
          :key="index"
        />
      </modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VLoader from './components/Loader'
import Modal from './components/modals/Modal'
import AlertMessage from './components/modals/AlertMessage'
import { mapState, mapGetters } from 'vuex'
import * as alertMutations from './store/modules/alert/mutation-types'

export default {
  name: 'App',
  components: {
    VLoader,
    Modal,
    AlertMessage
  },
  data () {
    return {
      currentRequestCount: 0,
      showLoader: false
    }
  },
  computed: {
    ...mapState('alert', {
      alert: state => state.alert
    }),
    ...mapGetters('alert', [
      'getViewableAlertNotificationMessages'
    ])
  },
  created () {
    const axios = Vue.$http
    axios.interceptors.request.use((config) => {
      this.increaseRequestCount()

      return config
    }, (error) => {
      this.decreaseRequestCount()

      return Promise.reject(error)
    })

    axios.interceptors.response.use((response) => {
      this.decreaseRequestCount()

      return response
    }, (error) => {
      this.decreaseRequestCount()

      return Promise.reject(error)
    })

    this.getViewableAlertNotificationMessages.length === 0 && this.closeErrorNotication()
  },
  methods: {
    increaseRequestCount () {
      this.currentRequestCount++

      setTimeout(this.setShowLoader, Vue.prototype.$container.config.loaderTimeout)
    },
    decreaseRequestCount () {
      this.currentRequestCount--

      if (this.currentRequestCount === 0) {
        this.setShowLoader()
      }
    },
    setShowLoader () {
      this.showLoader = this.currentRequestCount > 0
    },
    closeErrorNotication () {
      this.$store.commit(`alert/${alertMutations.DISMISS_ALERTS}`)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue